export default "__VITE_ASSET__DlYAUaxy__"